import pathRegexp from 'path-to-regexp'

export const getCurrentRoute = ({ router = [], pathname }) => {
    let result
    const filterRouter = (router = [], pathname) => {
        const current = router.find(({ routes, path = '/' }) => {
            return (path && pathRegexp(path).exec(pathname)) || (routes && filterRouter(routes, pathname))
        })
        if (current) {
            result = current
            return false
        }
    }
    filterRouter(router, pathname)
    return result
}
